exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".capcito-details {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n  padding-top: 12rem;\n}\n\n.capcito-details>div>svg {\n  height: 10rem;\n  width: 50rem;\n}\n\n.capcito-details>div p {\n  margin-top: 7rem;\n  white-space: pre-wrap;\n}\n\n@media only screen and (min-width: 1024px) {\n  .capcito-details>div>svg {\n    height: 20rem;\n    width: 70rem;\n  }\n\n  .capcito-details>div p {\n    font-size: 4rem;\n  }\n}\n\n", ""]);

// exports
